<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <NavbarTwo />
    </div>

    <div class="content-wrapper">
      <PageBanner pageTitle="Portfolio Details" mainTitle="Portfolio Details" />
      <PortfolioDetails />
    </div>
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../Layouts/TopHeader.vue";
import NavbarTwo from "../Layouts/NavbarTwo.vue";
import PageBanner from "../Common/PageBanner.vue";
import PortfolioDetails from "../PortfolioDetails/PortfolioDetails.vue";
import MainFooter from "../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "PortfolioDetailsPage",
  components: {
    TopHeader,
    NavbarTwo,
    PageBanner,
    PortfolioDetails,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script>